import { Checkbox, Dropdown, TextField } from "@fluentui/react";
import React from "react";
import { checkboxStyles } from "../../../common/views/DefaultStyles";
import { Utils } from "../../../common/views/Utils";
import { PictureUtils } from "../../../pictures/views/PictureUtilities";
import { NewLineModel } from "../../models/NewProductModel";
import { PriceDisplayType } from "../../models/ProductModel";
import { ProductUtils } from "../../ProductUtils";

export type LineInputProps = {
    form: NewLineModel;
    index: number;
    onValueChange: <K extends keyof NewLineModel>(index: number, field: K, value: NewLineModel[K]) => void;
}

export default function LineInputView({ form, index, onValueChange }: LineInputProps) {
    const width3 = Utils.getColumnWidth(3);
    const width9 = Utils.getColumnWidth(9);
    const size: any = { width: 110, height: 110 };

    const onFeatureValueChange = (name: string, value?: any) => {
        const feature = form.feature as any;
        feature[name] = value;
        onValueChange(index, "feature", feature);
    }

    const nameInput = () => {
        return <>
            <TextField
                label="Name"
                value={form.name}
                onChange={(_, v) => onValueChange(index, "name", v || "")}
            />
        </>;
    }

    const styleInput = () => {
        return <>
            <TextField
                label="Style"
                value={form.style}
                onChange={(_, v) => onValueChange(index, "style", v || "")}
            />
        </>;
    }

    const codeInput = () => {
        return <>
            <TextField
                label="Code"
                value={form.code}
                onChange={(_, v) => onValueChange(index, "code", v || "")}
            />
        </>;
    }

    const priceDisplayPicker = () => {
        return <div>
            <Dropdown
                label="Price Display"
                selectedKey={form.priceDisplayType}
                options={ProductUtils.getPriceDisplayOptions()}
                onChange={(_, v) => {
                    onValueChange(index, "priceDisplayType", (v?.key || 0) as PriceDisplayType);
                }}
            />
        </div>;
    }

    const nameElement = () => {
        return <div className="ms-Grid-row">
            <div className={width3}>
                {nameInput()}
            </div>
            <div className={width3}>
                {codeInput()}
            </div>
            <div className={width3}>
                {styleInput()}
            </div>
            <div className={width3}>
                {priceDisplayPicker()}
            </div>
        </div>
    }

    const deletedCheckbox = () => {
        return <>
            <Checkbox
                label="Deleted"
                checked={form.deleted}
                onChange={(_, v) => onValueChange(index, "deleted", v || false)}
                styles={checkboxStyles}
            />
        </>;
    }

    const activeCheckbox = () => {
        return <>
            <Checkbox
                label="Active"
                checked={form.active}
                onChange={(_, v) => onValueChange(index, "active", v || false)}
                styles={checkboxStyles}
            />
        </>;
    }

    const approvedCheckbox = () => {
        return <>
            <Checkbox
                label="Approved"
                checked={form.approved}
                onChange={(_, v) => onValueChange(index, "approved", v || false)}
                styles={checkboxStyles}
            />
        </>;
    }

    const choiceCheckbox = () => {
        return <>
            <Checkbox
                label="Choice"
                checked={form.feature.choice}
                onChange={(_, v) => onFeatureValueChange("choice", v || false)}
                styles={checkboxStyles}
            />
        </>;
    }

    const newArrivalCheckbox = () => {
        return <>
            <Checkbox
                label="New Arrival"
                checked={form.feature.newArrival}
                onChange={(_, v) => onFeatureValueChange("newArrival", v || false)}
                styles={checkboxStyles}
            />
        </>;
    }

    const specialSaleCheckbox = () => {
        return <>
            <Checkbox
                label="Special Sale"
                checked={form.feature.specialSale}
                onChange={(_, v) => onFeatureValueChange("specialSale", v || false)}
                styles={checkboxStyles}
            />
        </>;
    }

    const topSaleCheckbox = () => {
        return <>
            <Checkbox
                label="Top Sale"
                checked={form.feature.topSale}
                onChange={(_, v) => onFeatureValueChange("topSale", v || false)}
                styles={checkboxStyles}
            />
        </>;
    }

    const topRateCheckbox = () => {
        return <>
            <Checkbox
                label="Top Rate"
                checked={form.feature.topRate}
                onChange={(_, v) => onFeatureValueChange("topRate", v || false)}
                styles={checkboxStyles}
            />
        </>;
    }

    return <>
        <div className="ms-Grid-row">
            <div className={width3 + " pv-20"}>
                {form.uploadPicture !== undefined && <>
                    {PictureUtils.createImage2(
                        form.uploadPicture.type,
                        form.uploadPicture.bytes,
                        form.uploadPicture.category,
                        size,
                        () => { })}
                </>}
            </div>
            <div className={width9}>
                {nameElement()}

                <div className="ms-Grid-row pt-20">
                    <div className={width3}>{deletedCheckbox()}</div>
                    <div className={width3}>{activeCheckbox()}</div>
                    <div className={width3}>{approvedCheckbox()}</div>
                    <div className={width3}>{choiceCheckbox()}</div>
                </div>

                <div className="ms-Grid-row pt-20">
                    <div className={width3}>{newArrivalCheckbox()}</div>
                    <div className={width3}>{specialSaleCheckbox()}</div>
                    <div className={width3}>{topSaleCheckbox()}</div>
                    <div className={width3}>{topRateCheckbox()}</div>
                </div>
            </div>
        </div>
    </>;
}